export default __webpack_public_path__ + "static/media/product-design-guild-badge.c9194e03.png";